import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouteReuseStrategy } from "@angular/router";

import { IonicModule, IonicRouteStrategy } from "@ionic/angular";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { StatusBar } from "@ionic-native/status-bar/ngx";
import { IonicStorageModule } from "@ionic/storage";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { ComponentsModule } from "./components/components.module";
import { ServiceWorkerModule } from "@angular/service-worker";
import { environment } from "../environments/environment";
import { ReactiveFormsModule } from "@angular/forms";

import { HttpClientModule, HttpClient } from "@angular/common/http";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

import { SuperTabsModule } from "@ionic-super-tabs/angular";

import { AngularFireModule } from "@angular/fire";
import { AngularFireDatabaseModule } from "@angular/fire/database";
import { AngularFireAuthModule } from "@angular/fire/auth";
import { AngularFirestoreModule } from "@angular/fire/firestore";

import { InAppBrowser } from "@ionic-native/in-app-browser/ngx";
import { FirebaseX } from "@ionic-native/firebase-x/ngx";
import { Device } from "@ionic-native/device/ngx";
import { ScreenOrientation } from "@ionic-native/screen-orientation/ngx";
import { BLE } from "@ionic-native/ble/ngx";
import { Diagnostic } from '@ionic-native/diagnostic/ngx';
import { PowerManagement } from "@ionic-native/power-management/ngx";

import { FileTransfer } from "@ionic-native/file-transfer/ngx";
import { File } from "@ionic-native/file/ngx";
import { ImagePicker } from '@ionic-native/image-picker/ngx';
import { Crop } from '@ionic-native/crop/ngx';

import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';

//NGRX
//import { StoreModule } from '@ngrx/store';
// State
//import { metaReducers, reducers } from './core/reducers';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    IonicModule.forRoot({
      mode: "ios",
      swipeBackEnabled: false,
    }),
    IonicStorageModule.forRoot(),
    ReactiveFormsModule,
    AppRoutingModule,
    ComponentsModule,
    ServiceWorkerModule.register("/ngsw-worker.js", {
      enabled: environment.production,
    }),
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireAuthModule,
    AngularFirestoreModule,
    AngularFireDatabaseModule,
    SuperTabsModule.forRoot(),
    //StoreModule.forRoot(reducers, {metaReducers}),
  ],
  providers: [
    StatusBar,
    SplashScreen,
    InAppBrowser,
    FirebaseX,
    Device,
    ScreenOrientation,
    BLE,
    Diagnostic,
    PowerManagement,
    FileTransfer,
    File,
    ImagePicker,
    Crop,
    SocialSharing,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
